import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Breadcrumb';
import Footer from '../components/Footer';

function Topics({ topics, texts }) {
    const [visibleDescriptions, setVisibleDescriptions] = useState({});

    const toggleDescriptionVisibility = (topicId) => {
        setVisibleDescriptions(prev => ({
            ...prev,
            [topicId]: !prev[topicId]
        }));
    };

    return (
        <>
            <Breadcrumb topics={topics} texts={texts} />

            <div className="eaut-main-content topics">
                <h1>{texts.topics_title}</h1>
                <div className="topics-container">
                    {topics.map((topic) => (
                        <div key={topic.ID} class={topic.theme_color}>
                            <div className="image-container">
                                <div className="image-container-inner">
                                    {topic.image_url ? (
                                        <img alt="" className="image" src={topic.image_url} />
                                    ) : (
                                        <div className="image"></div>
                                    )}
                                </div>
                            </div>
                            <h2>{topic.title}</h2>
                            <p className="short-description">{topic.short_description}</p>
                            <div className={visibleDescriptions[topic.ID] ? 'long-description visible' : 'long-description'}>
                                <button onClick={() => toggleDescriptionVisibility(topic.ID)} className="toggle-description">
                                    {texts.topics_read_more_text} <span className="screen-reader-text">{topic.title}</span>
                                    <img alt="" src={texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/circle-plus.png'} />
                                </button>
                                <p>{topic.long_description}</p>
                            </div>
                            <Link className={'choose-topic ' + topic.ID} to={`/statement/${topic.ID}/${topic.statements[0].ID}`}>{texts.topics_choose_text} {topic.title.toLowerCase()}</Link>
                        </div>
                    ))}
                </div>

                <Footer texts={texts} />
            </div>
        </>
    );
}

export default Topics;
